import { createVuetify } from 'vuetify'
import type { ThemeDefinition } from 'vuetify'

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
//import { VDataTable } from 'vuetify/labs/VDataTable'

/*import { VBtn } from 'vuetify/components/VBtn'
import { VImg } from 'vuetify/components/VImg'
import { VIcon } from 'vuetify/components/VIcon'
//import { VSpacer } from 'vuetify/components/VGrid'
import { VTextField } from 'vuetify/components/VTextField'
import { VFileInput } from 'vuetify/components/VFileInput'
import { Ripple } from 'vuetify/directives'
*/

const myQuoteLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#f7f7f7',
    surface: '#ffffff',
    primary: '#f27c38',
    'primary-darken-1': '#c46229',
    secondary: '#273349',
    'secondary-darken-1': '#1c2535',
    accent: '#ffb347',
    info: '#1a73e8',
    success: '#22b07d',
    warning: '#ffb020',
    error: '#d64545',
    muted: '#8a94a6',
    outline: '#d8dce3'
  }
}

const myQuoteDarkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    background: '#0f141f',
    surface: '#171d29',
    primary: '#f27c38',
    'primary-darken-1': '#c46229',
    secondary: '#c5cede',
    'secondary-darken-1': '#94a1b4',
    accent: '#ffb347',
    info: '#4c8dff',
    success: '#3fd6a1',
    warning: '#ffb648',
    error: '#f27b7b',
    muted: '#98a0af',
    outline: '#2a3140'
  }
}

const adminDefaults = {
  global: {
    ripple: true
  },
  VAppBar: {
    flat: true,
    elevation: 0,
    height: 72
  },
  VToolbarTitle: {
    class: 'text-h6 font-weight-bold'
  },
  VBtn: {
    class: 'bo-btn',
    rounded: 'lg'
  },
  VCard: {
    elevation: 1,
    rounded: 'lg'
  },
  VTextField: {
    variant: 'outlined',
    density: 'comfortable'
  },
  VSelect: {
    variant: 'outlined',
    density: 'comfortable'
  },
  VDataTable: {
    density: 'comfortable',
    class: 'bo-table'
  }
} as const

const adminTypography = {
  fontFamily: '"Inter", "Apercu Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  h1: { fontFamily: 'inherit' },
  h2: { fontFamily: 'inherit' },
  h3: { fontFamily: 'inherit' },
  subtitle1: { fontFamily: 'inherit' },
  subtitle2: { fontFamily: 'inherit' },
  button: { fontFamily: 'inherit', letterSpacing: '0.08em' }
} as const

export default defineNuxtPlugin(nuxtApp => {
  const getInitialTheme = () => {
    // Only apply dark theme if we're in admin section
    if (typeof window !== 'undefined') {
      const isAdmin = window.location.pathname.startsWith('/admin')
      if (isAdmin) {
        const stored = sessionStorage.getItem('bo-theme')
        if (stored === 'dark') {
          return 'myQuoteDarkTheme'
        }
      }
    }

    return 'myQuoteLightTheme'
  }

  const vuetify = createVuetify({
    //components: {VBtn, VImg, VIcon, VTextField, VFileInput },
    //directives: {Ripple},
    components,
    directives,
    theme: {
      defaultTheme: getInitialTheme(),
      themes: {
        myQuoteLightTheme,
        myQuoteDarkTheme,
      },
    },
    defaults: adminDefaults,
    typography: adminTypography
  })

  nuxtApp.vueApp.use(vuetify)
})
